<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center"
    style="min-height: 80vh"
    v-if="consultandoInfoCotizaciones"
  >
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <section v-else>
    <ActionButtons :estatus="cotizacionInfo.estatus" />
    <div class="container mb-5">
      <CotizacionDatos
        :datos="cotizacionInfo"
        :totales="cotizacionTotales"
        :showSwitch="false"
      />
    </div>
    <ActionButtons :estatus="cotizacionInfo.estatus" />
  </section>

  <!-- Modal -->
  <div
    class="modal fade"
    id="modalAcciones"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header pb-4">
          <button
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            class="btn-close text-secondary"
            ref="btnCloseModal"
          >
            <h5>
              <i class="ri-close-line"></i>
            </h5>
          </button>
        </div>
        <form
          id="formAcciones"
          @submit.prevent="approve_decline($route.params.token)"
        >
          <div class="modal-body py-2">
            <div
              class="d-flex flex-column align-items-center justify-content-center"
            >
              <div class="row col-md-10 mx-auto d-block">
                <div class="col-12 form-group" v-if="formAprobar">
                  <label for="plazo">Plazo:</label>
                  <select name="plazo" id="plazo" class="form-control">
                    <option value="12">12 Meses</option>
                    <option value="24">24 Meses</option>
                    <option value="36">36 Meses</option>
                    <option value="48">48 Meses</option>
                    <option value="60">60 Meses</option>
                  </select>
                </div>
                <div class="col-12 form-group">
                  <label for="comentario">Comentario:</label>
                  <textarea
                    type="text"
                    class="form-control"
                    name="comentario"
                    rows="5"
                    :required="formRechazar"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center">
            <div
              class="d-flex flex-row align-items-center justify-content-center w-100"
            >
              <button class="btn bg-gradient-primary mb-0 rounded-pill me-2">
                <span
                  v-if="btnCargando"
                  class="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                Aceptar
              </button>
              <button
                type="button"
                class="btn bg-gradient-danger mb-0 rounded-pill"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import useCotizacion from "@/composables/useCotizacion";
import CotizacionDatos from "@/modules/dashboard/components/CotizacionDatos";
import ActionButtons from "./components/ActionButtons.vue";
import usePublicStore from "@/store/public";
import { storeToRefs } from "pinia";
import { onMounted } from "vue";

export default {
  components: {
    CotizacionDatos,
    ActionButtons,
  },
  setup() {
    const route = useRoute();
    const {
      fectchInfoCotizacionByToken,
      cotizacionInfo,
      cotizacionTotales,
      consultandoInfoCotizaciones,
      approve_decline,
      btnCargando,
      btnCloseModal,
    } = useCotizacion();

    const { modalAcciones, formAprobar, formRechazar } = storeToRefs(
      usePublicStore()
    );

    fectchInfoCotizacionByToken(route.params.token);

    onMounted(() => {
      modalAcciones.value = document.getElementById("modalAcciones");
    });

    return {
      cotizacionInfo,
      cotizacionTotales,
      consultandoInfoCotizaciones,
      modalAcciones,
      formAprobar,
      formRechazar,
      approve_decline,
      btnCargando,
      btnCloseModal,
    };
  },
};
</script>

<style>
main {
  background-color: #ffffff;
  opacity: 1;
  background-image: radial-gradient(
    #f4f4f4 1.1500000000000001px,
    #ffffff 1.1500000000000001px
  );
  background-size: 23px 23px;
}
</style>
